import { isNativePlatform } from "@/utils/native";
import { Tabs } from "@heroui-v3/react";
import { t } from "@lingui/core/macro";
import { CalendarDays, ReceiptText } from "lucide-react";
import { useCalendarMode, type CalendarMode } from "../useCalendarMode";

export const CalendarModeToggle = () => {
  const [mode, setMode] = useCalendarMode();

  // Grid-only on web, so there is nothing to switch between.
  if (!isNativePlatform()) return null;

  return (
    <Tabs
      aria-label={t`Prikaz koledarja`}
      selectedKey={mode}
      onSelectionChange={(key) => setMode(String(key) as CalendarMode)}
      variant="primary"
      className="shrink-0"
    >
      <Tabs.ListContainer>
        <Tabs.List aria-label={t`Prikaz koledarja`} className="shrink-0">
          <Tabs.Tab id="grid" aria-label={t`Mrežni prikaz`} className="px-2">
            <CalendarDays size={16} />
            <Tabs.Indicator />
          </Tabs.Tab>
          <Tabs.Tab id="list" aria-label={t`Seznam`} className="px-2">
            <ReceiptText size={16} />
            <Tabs.Indicator />
          </Tabs.Tab>
        </Tabs.List>
      </Tabs.ListContainer>
      <Tabs.Panel id="grid" className="m-0 hidden p-0">
        {null}
      </Tabs.Panel>
      <Tabs.Panel id="list" className="m-0 hidden p-0">
        {null}
      </Tabs.Panel>
    </Tabs>
  );
};
